const RiskLevel = {
  HIGH: "HIGH",
  MODERATE: "MODERATE",
  LOW: "LOW",
  NONE: "NONE",
};

export default Object.freeze(RiskLevel);
